// ---- HERE PASTE ALL STORAGE SUPPORT KEYS ---- //
export enum StorageAppKey {
    User = "user",
    Player = "player",
    Quests = "quests",
    QuestInfo = "QuestInfo",
    QuestsAll = "questsAll",
    Configuration = "CONFIGURATION",
    Fields = "Fields",
    TypeGame = "typeGame",
    CountPlayers = "countPlayers",
    GamePeople = "gamePeople"
}